export const categories = [
  {
    slug: 'shipin',
    name: '视频',
    icon: 'ri-movie-line',
    description: '海量高清视频资源，涵盖电影、电视剧、综艺、纪录片等多种类型',
    color: 'primary',
  },
  {
    slug: 'zixun',
    name: '资讯',
    icon: 'ri-newspaper-line',
    description: '实时热点资讯，紧跟时事动态，掌握最新信息',
    color: 'accent',
  },
  {
    slug: 'yule',
    name: '娱乐',
    icon: 'ri-emotion-happy-line',
    description: '明星八卦、综艺节目、娱乐动态，让你轻松一刻',
    color: 'secondary',
  },
  {
    slug: 'keji',
    name: '科技',
    icon: 'ri-smartphone-line',
    description: '前沿科技资讯、数码产品评测、AI人工智能最新进展',
    color: 'primary',
  },
  {
    slug: 'shenghuo',
    name: '生活',
    icon: 'ri-home-heart-line',
    description: '美食、旅游、健康、家居，让生活更加丰富多彩',
    color: 'accent',
  },
  {
    slug: 'jiaoyu',
    name: '教育',
    icon: 'ri-book-open-line',
    description: '在线课程、学习资源、考试资讯，助你不断成长',
    color: 'secondary',
  },
  {
    slug: 'tiyu',
    name: '体育',
    icon: 'ri-basketball-line',
    description: '赛事直播、体育新闻、健身教程，点燃运动激情',
    color: 'primary',
  },
  {
    slug: 'yinyue',
    name: '音乐',
    icon: 'ri-music-line',
    description: '热门歌曲、MV、音乐节目，随时随地享受音乐盛宴',
    color: 'accent',
  },
];